import React, { useState } from 'react';

import { formatPrice } from '../../FormatPrice';
import MaterialInput from '../../../Form/MaterialInput/MaterialInput';
import VoucherActions, { VoucherFromDom } from './VoucherActions';

interface Props {
    article: VoucherFromDom;
}

const VoucherWithDynamicPrice: React.FunctionComponent<Props> = (props) => {
    const [price, setPrice] = useState<string>('');
    const [blocked, setBlocked] = useState<boolean>(false);
    const currency = props.article.countryCode === 'CH' || props.article.countryCode === 'LI' ? 'CHF' : '€';
    const article: VoucherFromDom = {
        ...props.article,
        priceInCents: parseInt(price) * 100,
        price: formatPrice(props.article.countryCode, parseInt(price)),
        type: 'voucherWithDynamicPrice',
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPrice(e.currentTarget.value);
        setBlocked(parseInt(e.currentTarget.value) < 10 || parseInt(e.currentTarget.value) > 750);
    };

    return (
        <>
            <MaterialInput
                onChange={onChange}
                type="number"
                name="price"
                label={'Betrag in ' + currency + ' inkl. MwSt.'}
                value={price?.toString()}
            />
            <VoucherActions article={article} blocked={blocked} />
        </>
    );
};

export default VoucherWithDynamicPrice;
